import React from "react";
import { useNavigate } from "react-router";
import "./AdressCheckout.css";

function Otp() {
  const navigate = useNavigate();

  const handleOtp = () => {
    alert("Order Placed Successfully.");
    navigate("/");
  };
  return (
    <div className="mainAddress">
      <form
        className="addressForm"
        style={{ height: "220px", marginTop: "7%" }}
      >
        <h1>Please Enter Your OTP</h1>
        <input
          type="number"
          className="otp name"
          placeholder="Enter OTP (1234)"
        />
        <input type="submit" id="submit" onClick={handleOtp} />
      </form>
    </div>
  );
}

export default Otp;
